import { gigya, GigyaWrapper } from '../src/javascripts/gigya_wrapper'

// NOTE: {% javascript_pack_tag "gigya-user-login" %}
$(() => {
  const debug = (msg) => {
    if (process.env.DEBUG) {
      console.log(msg);
    }
  }

  const gigyaWrapper = new GigyaWrapper();
  const queryObject = gigyaWrapper.makeQueryObject(window.location.search);
  let screenName = 'gigya_user_login';
  if ($('#gigya_user_register').length > 0) {
    screenName = 'gigya_user_register';
  } else if ($('#gigya_update_profile').length > 0) {
    screenName = 'gigya_update_profile';
  }
  gigyaWrapper.gigyaSignIn(screenName, (response, isNewMemberRegistration) => {
    if (isNewMemberRegistration || response?.to_additonal_profile_member) {
      gigyaWrapper.redirectTo(response.redirect_path);
    } else if (queryObject['jwt_dest'] == 'iqform') {
      gigyaWrapper.toIqForm(queryObject['nexturl']);
    } else if (queryObject['jwt_dest'] == 'idlounge') {
      gigyaWrapper.toIdlounge(queryObject['nexturl']);
    } else if (queryObject['jwt_dest'] == 'moala') {
      gigyaWrapper.toMoala(queryObject['redirect_url']);
    } else if (queryObject['jwt_dest'] == 'ehonnavi') {
      gigyaWrapper.toEhonnavi(queryObject['redirect_url']);
    } else {
      if (queryObject['nexturl']) {
        gigyaWrapper.toIqForm(queryObject['nexturl']);
      } else {
        gigyaWrapper.redirectTo(response.redirect_path);
      }
    }
  });
});
